import { NavDropdown } from "react-bootstrap";
import styled from "styled-components";

const StyledNavDropdown = styled(NavDropdown)`
  .dropdown-toggle {
    color: white;
  }
  .dropdown-toggle::after {
    color: white;
  }
  .dropdown-toggle:hover::after {
    color: lightgray;
  }
  .dropdown-menu {
    z-index: 1001;
  }
`;

export default StyledNavDropdown;
